<section id="profile" class="content profile bgGray">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12 txt-content">
                <div class="profile-info">
                    <div class="logomarca">
                        <img src="../assets/images/dra-vanessa-lago-pneumologista2.png"
                            alt="Dra Vanessa Lago - Pneumologista - Botucatu, SP">
                        <div class="txt">
                            <h1>Dra. Vanessa Lago</h1>
                            <h2>Pneumologista</h2>
                        </div>
                    </div>
                    <p *ngFor="let item of profile.description">
                        {{ item }}
                    </p>
                    <a class="btn btn-default" href="http://lattes.cnpq.br/4045931146292664" target="_blank">
                        <i class="bi bi-file-earmark-medical"></i> Acessar currículo Lattes
                    </a>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 img-content">
                <div class="foto">
                    <img src="../../assets/images/dra-vanessa-lago-pneumologista-perfil2.png" alt="Dra Vanessa Lago - Pneumologista - Botucatu, SP" />
                </div>
            </div>
        </div>
    </div>
</section>